import {
    GET_CATALOG_REMOVE_CAPACITY,
    GET_CATALOG_REMOVE_DRIVE_TRAIN,
    GET_CATALOG_REMOVE_EQ_CLASS_CODE,
    GET_CATALOG_REMOVE_MAKE,
    GET_CATALOG_REMOVE_NO_OF_DOORS,
    GET_CATALOG_REMOVE_POWER_TYPE,
    GET_CATALOG_REMOVE_UPFIT,
    GET_CATALOG_REMOVE_VEHICLE_LEVEL,
    GET_CATALOG_REMOVE_YEAR,
    GET_CATALOG_UPDATE_CAPACITY,
    GET_CATALOG_UPDATE_CAPACITY_SAVE,
    GET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    GET_CATALOG_UPDATE_DRIVE_TRAIN,
    GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    GET_CATALOG_UPDATE_EQ_CLASS_CODE,
    GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    GET_CATALOG_UPDATE_MAKE,
    GET_CATALOG_UPDATE_MAKE_SAVE,
    GET_CATALOG_UPDATE_MAKE_VALIDATE,
    GET_CATALOG_UPDATE_MODEL_SAVE,
    GET_CATALOG_UPDATE_MODEL_VALIDATE,
    GET_CATALOG_UPDATE_NO_OF_DOORS,
    GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    GET_CATALOG_UPDATE_POWER_TYPE,
    GET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    GET_CATALOG_UPDATE_UPFIT,
    GET_CATALOG_UPDATE_UPFIT_SAVE,
    GET_CATALOG_UPDATE_UPFIT_VALIDATE,
    GET_CATALOG_UPDATE_VEHICLE_LEVEL,
    GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    GET_CATALOG_UPDATE_YEAR,
    GET_CATALOG_UPDATE_YEAR_SAVE,
    GET_CATALOG_UPDATE_YEAR_VALIDATE,
    SET_CATALOG_REMOVE_CAPACITY,
    SET_CATALOG_REMOVE_DRIVE_TRAIN,
    SET_CATALOG_REMOVE_EQ_CLASS_CODE,
    SET_CATALOG_REMOVE_MAKE,
    SET_CATALOG_REMOVE_NO_OF_DOORS,
    SET_CATALOG_REMOVE_POWER_TYPE,
    SET_CATALOG_REMOVE_UPFIT,
    SET_CATALOG_REMOVE_VEHICLE_LEVEL,
    SET_CATALOG_REMOVE_YEAR,
    SET_CATALOG_UPDATE_CAPACITY,
    SET_CATALOG_UPDATE_CAPACITY_SAVE,
    SET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    SET_CATALOG_UPDATE_MAKE,
    SET_CATALOG_UPDATE_MAKE_SAVE,
    SET_CATALOG_UPDATE_MAKE_VALIDATE,
    SET_CATALOG_UPDATE_MODEL_SAVE,
    SET_CATALOG_UPDATE_MODEL_VALIDATE,
    SET_CATALOG_UPDATE_NO_OF_DOORS,
    SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    SET_CATALOG_UPDATE_POWER_TYPE,
    SET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_UPFIT,
    SET_CATALOG_UPDATE_UPFIT_SAVE,
    SET_CATALOG_UPDATE_UPFIT_VALIDATE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    SET_CATALOG_UPDATE_YEAR,
    SET_CATALOG_UPDATE_YEAR_SAVE,
    SET_CATALOG_UPDATE_YEAR_VALIDATE,

    GET_BUDGETING_PERCENT_LIST,
    SET_BUDGETING_PERCENT_LIST,
    SAVE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_SAVED,
    VALIDATE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_VALID,
    DELETE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_DELETED,

    GET_USEFUL_LIFE_LIST,
    SET_USEFUL_LIFE_LIST,
    SAVE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_SAVED,
    VALIDATE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_VALID,
    DELETE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_DELETED,

    GET_CATALOG_UPDATE_MODEL,
    SET_CATALOG_UPDATE_MODEL,
    GET_CATALOG_REMOVE_MODEL,
    SET_CATALOG_REMOVE_MODEL,
    GET_CATALOG_UPDATE_STATE_AVAILABILITY,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY,
    GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    GET_CATALOG_REMOVE_STATE_AVAILABILITY,
    SET_CATALOG_REMOVE_STATE_AVAILABILITY,
    GET_CATALOG_UPDATE_PROGRAM_STATUS,
    SET_CATALOG_UPDATE_PROGRAM_STATUS,
    GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    GET_CATALOG_REMOVE_PROGRAM_STATUS,
    SET_CATALOG_REMOVE_PROGRAM_STATUS,

    GET_CATALOG_UPDATE_ANNUAL_HOURS,
    SET_CATALOG_UPDATE_ANNUAL_HOURS,
    GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    GET_CATALOG_REMOVE_ANNUAL_HOURS,
    SET_CATALOG_REMOVE_ANNUAL_HOURS,

    GET_CATALOG_UPDATE_DECK_SIZE,
    SET_CATALOG_UPDATE_DECK_SIZE,
    GET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    SET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    GET_CATALOG_REMOVE_DECK_SIZE,
    SET_CATALOG_REMOVE_DECK_SIZE,

    GET_CATALOG_UPDATE_DECK_TYPE,
    SET_CATALOG_UPDATE_DECK_TYPE,
    GET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    SET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_DECK_TYPE,
    SET_CATALOG_REMOVE_DECK_TYPE,

    GET_CATALOG_UPDATE_SIZE,
    SET_CATALOG_UPDATE_SIZE,
    GET_CATALOG_UPDATE_SIZE_SAVE,
    SET_CATALOG_UPDATE_SIZE_SAVE,
    GET_CATALOG_UPDATE_SIZE_VALIDATE,
    SET_CATALOG_UPDATE_SIZE_VALIDATE,
    GET_CATALOG_REMOVE_SIZE,
    SET_CATALOG_REMOVE_SIZE,

    GET_CATALOG_UPDATE_LENGTH,
    SET_CATALOG_UPDATE_LENGTH,
    GET_CATALOG_UPDATE_LENGTH_SAVE,
    SET_CATALOG_UPDATE_LENGTH_SAVE,
    GET_CATALOG_UPDATE_LENGTH_VALIDATE,
    SET_CATALOG_UPDATE_LENGTH_VALIDATE,
    GET_CATALOG_REMOVE_LENGTH,
    SET_CATALOG_REMOVE_LENGTH,

    GET_CATALOG_UPDATE_AUTONOMOUS,
    SET_CATALOG_UPDATE_AUTONOMOUS,
    GET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    SET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    GET_CATALOG_REMOVE_AUTONOMOUS,
    SET_CATALOG_REMOVE_AUTONOMOUS,

    GET_CATALOG_UPDATE_CATEGORY,
    SET_CATALOG_UPDATE_CATEGORY,
    GET_CATALOG_UPDATE_CATEGORY_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_SAVE,
    GET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY,
    SET_CATALOG_REMOVE_CATEGORY,

    GET_CATALOG_UPDATE_CATEGORY_TYPE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE,
    GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY_TYPE,
    SET_CATALOG_REMOVE_CATEGORY_TYPE,

    GET_CATALOG_UPDATE_CATEGORY2,
    SET_CATALOG_UPDATE_CATEGORY2,
    GET_CATALOG_UPDATE_CATEGORY2_SAVE,
    SET_CATALOG_UPDATE_CATEGORY2_SAVE,
    GET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY2,
    SET_CATALOG_REMOVE_CATEGORY2,

    //Type
    GET_CATALOG_UPDATE_TYPE,
    SET_CATALOG_UPDATE_TYPE,
    GET_CATALOG_UPDATE_TYPE_SAVE,
    SET_CATALOG_UPDATE_TYPE_SAVE,
    GET_CATALOG_UPDATE_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_TYPE,
    SET_CATALOG_REMOVE_TYPE,
     
    //Tags
    GET_TAGS_LIST,
    SET_TAGS_LIST,
    SAVE_TAGS_OPTION,
    IS_TAGS_OPTION_SAVED,
    VALIDATE_TAGS_OPTION,
    IS_TAGS_OPTION_VALID,
    DELETE_TAGS_OPTION,
    IS_TAGS_OPTION_DELETED,

    //Edit capacity
    GET_EDIT_CATALOG_VEHICLE_CAPACITY,
    SET_EDIT_CATALOG_VEHICLE_CAPACITY,

    //Vehicle Class
    GET_CATALOG_UPDATE_VEHICLE_CLASS,
    SET_CATALOG_UPDATE_VEHICLE_CLASS,
    GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    GET_CATALOG_REMOVE_VEHICLE_CLASS,
    SET_CATALOG_REMOVE_VEHICLE_CLASS,

    //Group Type
    GET_CATALOG_UPDATE_GROUP_TYPE,
    SET_CATALOG_UPDATE_GROUP_TYPE,
    GET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    SET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_GROUP_TYPE,
    SET_CATALOG_REMOVE_GROUP_TYPE,

    //Class Type
    GET_CATALOG_UPDATE_CLASS_TYPE,
    SET_CATALOG_UPDATE_CLASS_TYPE,
    GET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    SET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_CLASS_TYPE,
    SET_CATALOG_REMOVE_CLASS_TYPE,

    //Gross Weight
    GET_CATALOG_UPDATE_GROSS_WEIGHT,
    SET_CATALOG_UPDATE_GROSS_WEIGHT,
    GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    GET_CATALOG_REMOVE_GROSS_WEIGHT,
    SET_CATALOG_REMOVE_GROSS_WEIGHT,

    ///Trim
    GET_CATALOG_UPDATE_TRIM,
    SET_CATALOG_UPDATE_TRIM,
    GET_CATALOG_UPDATE_TRIM_SAVE,
    SET_CATALOG_UPDATE_TRIM_SAVE,
    SET_CATALOG_UPDATE_TRIM_VALIDATE,
    GET_CATALOG_UPDATE_TRIM_VALIDATE,
    GET_CATALOG_REMOVE_TRIM,
    SET_CATALOG_REMOVE_TRIM,

} from "./CatalogItemDropDownUpdateType"

///No.Of.Door
const getCatalogUpdateNoOfDoors = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_NO_OF_DOORS,
    subTypeId,
    attributeName
});

const setCatalogUpdateNoOfDoors = (catalogUpdateNoOfDoors: any) => ({
    type: SET_CATALOG_UPDATE_NO_OF_DOORS,
    catalogUpdateNoOfDoors: catalogUpdateNoOfDoors
});

const getCatalogUpdateNoOfDoorSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    payload
});

const setCatalogUpdateNoOfDoorSave = (isCatalogUpdateNoOfDoorSaved: any) => ({
    type: SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    isCatalogUpdateNoOfDoorSaved: isCatalogUpdateNoOfDoorSaved
});

const getCatalogUpdateNoOfDoorValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    payload
});

const setCatalogUpdateNoOfDoorValidate = (isCatalogUpdateNoOfDoorValid: any) => ({
    type: SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    isCatalogUpdateNoOfDoorValid: isCatalogUpdateNoOfDoorValid
});


const getCatalogRemoveNoOfDoor = (payload: any) => ({
    type: GET_CATALOG_REMOVE_NO_OF_DOORS,
    payload
});

const setCatalogRemoveNoOfDoor = (isCatalogNoOfDoorRemoved: any) => ({
    type: SET_CATALOG_REMOVE_NO_OF_DOORS,
    isCatalogNoOfDoorRemoved: isCatalogNoOfDoorRemoved
});

///Year
const getCatalogUpdateYear = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_YEAR,
    subTypeId, attributeName
});

const setCatalogUpdateYear = (catalogUpdateYear: any) => ({
    type: SET_CATALOG_UPDATE_YEAR,
    catalogUpdateYear: catalogUpdateYear
});

const getCatalogUpdateYearSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_YEAR_SAVE,
    payload
});

const setCatalogUpdateYearSave = (isCatalogUpdateYearSaved: any) => ({
    type: SET_CATALOG_UPDATE_YEAR_SAVE,
    isCatalogUpdateYearSaved: isCatalogUpdateYearSaved
});

const getCatalogUpdateYearValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_YEAR_VALIDATE,
    payload
});

const setCatalogUpdateYearValidate = (isCatalogUpdateYearValid: any) => ({
    type: SET_CATALOG_UPDATE_YEAR_VALIDATE,
    isCatalogUpdateYearValid: isCatalogUpdateYearValid
});


const getCatalogRemoveYear = (payload: any) => ({
    type: GET_CATALOG_REMOVE_YEAR,
    payload
});

const setCatalogRemoveYear = (isCatalogYearRemoved: any) => ({
    type: SET_CATALOG_REMOVE_YEAR,
    isCatalogYearRemoved: isCatalogYearRemoved
});


///Capacity
const getCatalogUpdateCapacity = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_CAPACITY,
    subTypeId,
    attributeName
});

const setCatalogUpdateCapacity = (catalogUpdateCapacity: any) => ({
    type: SET_CATALOG_UPDATE_CAPACITY,
    catalogUpdateCapacity: catalogUpdateCapacity
});

const getCatalogUpdateCapacitySave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CAPACITY_SAVE,
    payload
});

const setCatalogUpdateCapacitySave = (isCatalogUpdateCapacitySaved: any) => ({
    type: SET_CATALOG_UPDATE_CAPACITY_SAVE,
    isCatalogUpdateCapacitySaved: isCatalogUpdateCapacitySaved
});

const getCatalogUpdateCapacityValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    payload
});

const setCatalogUpdateCapacityValidate = (isCatalogUpdateCapacityValid: any) => ({
    type: SET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    isCatalogUpdateCapacityValid: isCatalogUpdateCapacityValid
});


const getCatalogRemoveCapacity = (payload: any) => ({
    type: GET_CATALOG_REMOVE_CAPACITY,
    payload
});

const setCatalogRemoveCapacity = (isCatalogCapacityRemoved: any) => ({
    type: SET_CATALOG_REMOVE_CAPACITY,
    isCatalogCapacityRemoved: isCatalogCapacityRemoved
});

///Upfit
const getCatalogUpdateUpfit = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_UPFIT,
    subTypeId,
    attributeName
});

const setCatalogUpdateUpfit = (catalogUpdateUpfit: any) => ({
    type: SET_CATALOG_UPDATE_UPFIT,
    catalogUpdateUpfit: catalogUpdateUpfit
});

const getCatalogUpdateUpfitSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_UPFIT_SAVE,
    payload
});

const setCatalogUpdateUpfitSave = (isCatalogUpdateUpfitSaved: any) => ({
    type: SET_CATALOG_UPDATE_UPFIT_SAVE,
    isCatalogUpdateUpfitSaved: isCatalogUpdateUpfitSaved
});

const getCatalogUpdateUpfitValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_UPFIT_VALIDATE,
    payload
});

const setCatalogUpdateUpfitValidate = (isCatalogUpdateUpfitValid: any) => ({
    type: SET_CATALOG_UPDATE_UPFIT_VALIDATE,
    isCatalogUpdateUpfitValid: isCatalogUpdateUpfitValid
});


const getCatalogRemoveUpfit = (payload: any) => ({
    type: GET_CATALOG_REMOVE_UPFIT,
    payload
});

const setCatalogRemoveUpfit = (isCatalogUpfitRemoved: any) => ({
    type: SET_CATALOG_REMOVE_UPFIT,
    isCatalogUpfitRemoved: isCatalogUpfitRemoved
});

///Drive train
const getCatalogUpdateDriveTrain = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_DRIVE_TRAIN,
    subTypeId,
    attributeName
});

const setCatalogUpdateDriveTrain = (catalogUpdateDriveTrain: any) => ({
    type: SET_CATALOG_UPDATE_DRIVE_TRAIN,
    catalogUpdateDriveTrain: catalogUpdateDriveTrain
});

const getCatalogUpdateDriveTrainSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    payload
});

const setCatalogUpdateDriveTrainSave = (isCatalogUpdateDriveTrainSaved: any) => ({
    type: SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    isCatalogUpdateDriveTrainSaved: isCatalogUpdateDriveTrainSaved
});

const getCatalogUpdateDriveTrainValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    payload
});

const setCatalogUpdateDriveTrainValidate = (isCatalogUpdateDriveTrainValid: any) => ({
    type: SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    isCatalogUpdateDriveTrainValid: isCatalogUpdateDriveTrainValid
});


const getCatalogRemoveDriveTrain = (payload: any) => ({
    type: GET_CATALOG_REMOVE_DRIVE_TRAIN,
    payload
});

const setCatalogRemoveDriveTrain = (isCatalogDriveTrainRemoved: any) => ({
    type: SET_CATALOG_REMOVE_DRIVE_TRAIN,
    isCatalogDriveTrainRemoved: isCatalogDriveTrainRemoved
});

///Power type
const getCatalogUpdatePowerType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_POWER_TYPE,
    subTypeId,
    attributeName
});

const setCatalogUpdatePowerType = (catalogUpdatePowerType: any) => ({
    type: SET_CATALOG_UPDATE_POWER_TYPE,
    catalogUpdatePowerType: catalogUpdatePowerType
});

const getCatalogUpdatePowerTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    payload
});

const setCatalogUpdatePowerTypeSave = (isCatalogUpdatePowerTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    isCatalogUpdatePowerTypeSaved: isCatalogUpdatePowerTypeSaved
});

const getCatalogUpdatePowerTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    payload
});

const setCatalogUpdatePowerTypeValidate = (isCatalogUpdatePowerTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    isCatalogUpdatePowerTypeValid: isCatalogUpdatePowerTypeValid
});


const getCatalogRemovePowerType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_POWER_TYPE,
    payload
});

const setCatalogRemovePowerType = (isCatalogPowerTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_POWER_TYPE,
    isCatalogPowerTypeRemoved: isCatalogPowerTypeRemoved
});

///Vehicle Level
const getCatalogUpdateVehicleLevel = () => ({
    type: GET_CATALOG_UPDATE_VEHICLE_LEVEL
});

const setCatalogUpdateVehicleLevel = (catalogUpdateVehicleLevel: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_LEVEL,
    catalogUpdateVehicleLevel: catalogUpdateVehicleLevel
});

const getCatalogUpdateVehicleLevelSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    payload
});

const setCatalogUpdateVehicleLevelSave = (isCatalogUpdateVehicleLevelSaved: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    isCatalogUpdateVehicleLevelSaved: isCatalogUpdateVehicleLevelSaved
});

const getCatalogUpdateVehicleLevelValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    payload
});

const setCatalogUpdateVehicleLevelValidate = (isCatalogUpdateVehicleLevelValid: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    isCatalogUpdateVehicleLevelValid: isCatalogUpdateVehicleLevelValid
});


const getCatalogRemoveVehicleLevel = (payload: any) => ({
    type: GET_CATALOG_REMOVE_VEHICLE_LEVEL,
    payload
});

const setCatalogRemoveVehicleLevel = (isCatalogVehicleLevelRemoved: any) => ({
    type: SET_CATALOG_REMOVE_VEHICLE_LEVEL,
    isCatalogVehicleLevelRemoved: isCatalogVehicleLevelRemoved
});

///Eq Class Code
const getCatalogUpdateEqClassCode = (subTypeId: any) => ({
    type: GET_CATALOG_UPDATE_EQ_CLASS_CODE,
    subTypeId
});

const setCatalogUpdateEqClassCode = (catalogUpdateEqClassCode: any) => ({
    type: SET_CATALOG_UPDATE_EQ_CLASS_CODE,
    catalogUpdateEqClassCode: catalogUpdateEqClassCode
});

const getCatalogUpdateEqClassCodeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    payload
});

const setCatalogUpdateEqClassCodeSave = (isCatalogUpdateEqClassCodeSaved: any) => ({
    type: SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    isCatalogUpdateEqClassCodeSaved: isCatalogUpdateEqClassCodeSaved
});

const getCatalogUpdateEqClassCodeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    payload
});

const setCatalogUpdateEqClassCodeValidate = (isCatalogUpdateEqClassCodeValid: any) => ({
    type: SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    isCatalogUpdateEqClassCodeValid: isCatalogUpdateEqClassCodeValid
});


const getCatalogRemoveEqClassCode = (payload: any) => ({
    type: GET_CATALOG_REMOVE_EQ_CLASS_CODE,
    payload
});

const setCatalogRemoveEqClassCode = (isCatalogEqClassCodeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_EQ_CLASS_CODE,
    isCatalogEqClassCodeRemoved: isCatalogEqClassCodeRemoved
});

///Make
const getCatalogUpdateMake = (subTypeId: any, isEquipment: any) => ({
    type: GET_CATALOG_UPDATE_MAKE,
    subTypeId,
    isEquipment
});

const setCatalogUpdateMake = (catalogUpdateMake: any) => ({
    type: SET_CATALOG_UPDATE_MAKE,
    catalogUpdateMake: catalogUpdateMake
});

const getCatalogUpdateMakeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_MAKE_SAVE,
    payload
});

const setCatalogUpdateMakeSave = (isCatalogUpdateMakeSaved: any) => ({
    type: SET_CATALOG_UPDATE_MAKE_SAVE,
    isCatalogUpdateMakeSaved: isCatalogUpdateMakeSaved
});

const getCatalogUpdateMakeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_MAKE_VALIDATE,
    payload
});

const setCatalogUpdateMakeValidate = (isCatalogUpdateMakeValid: any) => ({
    type: SET_CATALOG_UPDATE_MAKE_VALIDATE,
    isCatalogUpdateMakeValid: isCatalogUpdateMakeValid
});

const getCatalogRemoveMake = (payload: any) => ({
    type: GET_CATALOG_REMOVE_MAKE,
    payload
});

const setCatalogRemoveMake = (isCatalogMakeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_MAKE,
    isCatalogMakeRemoved: isCatalogMakeRemoved
});

///StateAvailability
const getCatalogUpdateStateAvailability = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_STATE_AVAILABILITY,
    subTypeId,
    attributeName
});

const setCatalogUpdateStateAvailability = (catalogUpdateStateAvailability: any) => ({
    type: SET_CATALOG_UPDATE_STATE_AVAILABILITY,
    catalogUpdateStateAvailability: catalogUpdateStateAvailability
});

const getCatalogUpdateStateAvailabilitySave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    payload
});

const setCatalogUpdateStateAvailabilitySave = (isCatalogUpdateStateAvailabilitySaved: any) => ({
    type: SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    isCatalogUpdateStateAvailabilitySaved: isCatalogUpdateStateAvailabilitySaved
});

const getCatalogUpdateStateAvailabilityValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    payload
});

const setCatalogUpdateStateAvailabilityValidate = (isCatalogUpdateStateAvailabilityValid: any) => ({
    type: SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    isCatalogUpdateStateAvailabilityValid: isCatalogUpdateStateAvailabilityValid
});

const getCatalogRemoveStateAvailability = (payload: any) => ({
    type: GET_CATALOG_REMOVE_STATE_AVAILABILITY,
    payload
});

const setCatalogRemoveStateAvailability = (isCatalogStateAvailabilityRemoved: any) => ({
    type: SET_CATALOG_REMOVE_STATE_AVAILABILITY,
    isCatalogStateAvailabilityRemoved: isCatalogStateAvailabilityRemoved
});

///Model
const getCatalogUpdateModelSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_MODEL_SAVE,
    payload
});

const setCatalogUpdateModelSave = (isCatalogUpdateModelSaved: any) => ({
    type: SET_CATALOG_UPDATE_MODEL_SAVE,
    isCatalogUpdateModelSaved: isCatalogUpdateModelSaved
});

const getCatalogUpdateModelValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_MODEL_VALIDATE,
    payload
});

const setCatalogUpdateModelValidate = (isCatalogUpdateModelValid: any) => ({
    type: SET_CATALOG_UPDATE_MODEL_VALIDATE,
    isCatalogUpdateModelValid: isCatalogUpdateModelValid
});

const getCatalogUpdateModel = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_MODEL,
    subTypeId,
    attributeName
});

const setCatalogUpdateModel = (catalogUpdateModel: any) => ({
    type: SET_CATALOG_UPDATE_MODEL,
    catalogUpdateModel: catalogUpdateModel
});

const getCatalogRemoveModel = (payload: any) => ({
    type: GET_CATALOG_REMOVE_MODEL,
    payload
});

const setCatalogRemoveModel = (isCatalogModelRemoved: any) => ({
    type: SET_CATALOG_REMOVE_MODEL,
    isCatalogModelRemoved: isCatalogModelRemoved
});

///Budget Percent
const getBudgetingPercentList = (payload: any, attributeName: any) => ({
    type: GET_BUDGETING_PERCENT_LIST,
    payload,
    attributeName
});

const setBudgetingPercentList = (list: any) => ({
    type: SET_BUDGETING_PERCENT_LIST,
    list
});

const saveBudgetingPercentOption = (payload: any) => ({
    type: SAVE_BUDGETING_PERCENT_OPTION,
    payload
});

const isBudgetingPercentOptionSaved = (value: any) => ({
    type: IS_BUDGETING_PERCENT_OPTION_SAVED,
    value
});

const validateBudgetingPercentOption = (payload: any) => ({
    type: VALIDATE_BUDGETING_PERCENT_OPTION,
    payload
});

const isBudgetingPercentOptionValid = (value: any) => ({
    type: IS_BUDGETING_PERCENT_OPTION_VALID,
    value
});

const deleteBudgetingPercentOption = (payload: any) => ({
    type: DELETE_BUDGETING_PERCENT_OPTION,
    payload
});

const isBudgetingPercentOptionDeleted = (value: any) => ({
    type: IS_BUDGETING_PERCENT_OPTION_DELETED,
    value
});

const getUsefulLifeList = (payload: any, attributeName: any) => ({
    type: GET_USEFUL_LIFE_LIST,
    payload,
    attributeName
});

const setUsefulLifeList = (list: any) => ({
    type: SET_USEFUL_LIFE_LIST,
    list
});

const saveUsefulLifeOption = (payload: any) => ({
    type: SAVE_USEFUL_LIFE_OPTION,
    payload
});

const isUsefulLifeOptionSaved = (value: any) => ({
    type: IS_USEFUL_LIFE_OPTION_SAVED,
    value
});

const validateUsefulLifeOption = (payload: any) => ({
    type: VALIDATE_USEFUL_LIFE_OPTION,
    payload
});

const isUsefulLifeOptionValid = (value: any) => ({
    type: IS_USEFUL_LIFE_OPTION_VALID,
    value
});

const deleteUsefulLifeOption = (payload: any) => ({
    type: DELETE_USEFUL_LIFE_OPTION,
    payload
});

const isUsefulLifeOptionDeleted = (value: any) => ({
    type: IS_USEFUL_LIFE_OPTION_DELETED,
    value
});

///Program status
const getCatalogUpdateProgramStatus = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_PROGRAM_STATUS,
    subTypeId,
    attributeName
});

const setCatalogUpdateProgramStatus = (catalogUpdateProgramStatus: any) => ({
    type: SET_CATALOG_UPDATE_PROGRAM_STATUS,
    catalogUpdateProgramStatus: catalogUpdateProgramStatus
});

const getCatalogUpdateProgramStatusSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    payload
});

const setCatalogUpdateProgramStatusSave = (isCatalogUpdateProgramStatusSaved: any) => ({
    type: SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    isCatalogUpdateProgramStatusSaved: isCatalogUpdateProgramStatusSaved
});

const getCatalogUpdateProgramStatusValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    payload
});

const setCatalogUpdateProgramStatusValidate = (isCatalogUpdateProgramStatusValid: any) => ({
    type: SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    isCatalogUpdateProgramStatusValid: isCatalogUpdateProgramStatusValid
});

const getCatalogRemoveProgramStatus = (payload: any) => ({
    type: GET_CATALOG_REMOVE_PROGRAM_STATUS,
    payload
});

const setCatalogRemoveProgramStatus = (isCatalogProgramStatusRemoved: any) => ({
    type: SET_CATALOG_REMOVE_PROGRAM_STATUS,
    isCatalogProgramStatusRemoved: isCatalogProgramStatusRemoved
});

///Annual Hours
const getCatalogUpdateAnnualHours = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_ANNUAL_HOURS,
    subTypeId,
    attributeName
});

const setCatalogUpdateAnnualHours = (catalogUpdateAnnualHours: any) => ({
    type: SET_CATALOG_UPDATE_ANNUAL_HOURS,
    catalogUpdateAnnualHours: catalogUpdateAnnualHours
});

const getCatalogUpdateAnnualHoursSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    payload
});

const setCatalogUpdateAnnualHoursSave = (isCatalogUpdateAnnualHoursSaved: any) => ({
    type: SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    isCatalogUpdateAnnualHoursSaved: isCatalogUpdateAnnualHoursSaved
});

const getCatalogUpdateAnnualHoursValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    payload
});

const setCatalogUpdateAnnualHoursValidate = (isCatalogUpdateAnnualHoursValid: any) => ({
    type: SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    isCatalogUpdateAnnualHoursValid: isCatalogUpdateAnnualHoursValid
});

const getCatalogRemoveAnnualHours = (payload: any) => ({
    type: GET_CATALOG_REMOVE_ANNUAL_HOURS,
    payload
});

const setCatalogRemoveAnnualHours = (isCatalogAnnualHoursRemoved: any) => ({
    type: SET_CATALOG_REMOVE_ANNUAL_HOURS,
    isCatalogAnnualHoursRemoved: isCatalogAnnualHoursRemoved
});

///Deck Size
const getCatalogUpdateDeckSize = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_DECK_SIZE,
    subTypeId,
    attributeName
});

const setCatalogUpdateDeckSize = (catalogUpdateDeckSize: any) => ({
    type: SET_CATALOG_UPDATE_DECK_SIZE,
    catalogUpdateDeckSize: catalogUpdateDeckSize
});

const getCatalogUpdateDeckSizeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    payload
});

const setCatalogUpdateDeckSizeSave = (isCatalogUpdateDeckSizeSaved: any) => ({
    type: SET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    isCatalogUpdateDeckSizeSaved: isCatalogUpdateDeckSizeSaved
});

const getCatalogUpdateDeckSizeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    payload
});

const setCatalogUpdateDeckSizeValidate = (isCatalogUpdateDeckSizeValid: any) => ({
    type: SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    isCatalogUpdateDeckSizeValid: isCatalogUpdateDeckSizeValid
});

const getCatalogRemoveDeckSize = (payload: any) => ({
    type: GET_CATALOG_REMOVE_DECK_SIZE,
    payload
});

const setCatalogRemoveDeckSize = (isCatalogDeckSizeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_DECK_SIZE,
    isCatalogDeckSizeRemoved: isCatalogDeckSizeRemoved
});

///Deck Type
const getCatalogUpdateDeckType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_DECK_TYPE,
    subTypeId,
    attributeName
});

const setCatalogUpdateDeckType = (catalogUpdateDeckType: any) => ({
    type: SET_CATALOG_UPDATE_DECK_TYPE,
    catalogUpdateDeckType: catalogUpdateDeckType
});

const getCatalogUpdateDeckTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    payload
});

const setCatalogUpdateDeckTypeSave = (isCatalogUpdateDeckTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    isCatalogUpdateDeckTypeSaved: isCatalogUpdateDeckTypeSaved
});

const getCatalogUpdateDeckTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    payload
});

const setCatalogUpdateDeckTypeValidate = (isCatalogUpdateDeckTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    isCatalogUpdateDeckTypeValid: isCatalogUpdateDeckTypeValid
});

const getCatalogRemoveDeckType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_DECK_TYPE,
    payload
});

const setCatalogRemoveDeckType = (isCatalogDeckTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_DECK_TYPE,
    isCatalogDeckTypeRemoved: isCatalogDeckTypeRemoved
});

///Size
const getCatalogUpdateSize = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_SIZE,
    subTypeId,
    attributeName
});

const setCatalogUpdateSize = (catalogUpdateSize: any) => ({
    type: SET_CATALOG_UPDATE_SIZE,
    catalogUpdateSize: catalogUpdateSize
});

const getCatalogUpdateSizeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_SIZE_SAVE,
    payload
});

const setCatalogUpdateSizeSave = (isCatalogUpdateSizeSaved: any) => ({
    type: SET_CATALOG_UPDATE_SIZE_SAVE,
    isCatalogUpdateSizeSaved: isCatalogUpdateSizeSaved
});

const getCatalogUpdateSizeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_SIZE_VALIDATE,
    payload
});

const setCatalogUpdateSizeValidate = (isCatalogUpdateSizeValid: any) => ({
    type: SET_CATALOG_UPDATE_SIZE_VALIDATE,
    isCatalogUpdateSizeValid: isCatalogUpdateSizeValid
});

const getCatalogRemoveSize = (payload: any) => ({
    type: GET_CATALOG_REMOVE_SIZE,
    payload
});

const setCatalogRemoveSize = (isCatalogSizeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_SIZE,
    isCatalogSizeRemoved: isCatalogSizeRemoved
});

///Length
const getCatalogUpdateLength = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_LENGTH,
    subTypeId,
    attributeName
});

const setCatalogUpdateLength = (catalogUpdateLength: any) => ({
    type: SET_CATALOG_UPDATE_LENGTH,
    catalogUpdateLength: catalogUpdateLength
});

const getCatalogUpdateLengthSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_LENGTH_SAVE,
    payload
});

const setCatalogUpdateLengthSave = (isCatalogUpdateLengthSaved: any) => ({
    type: SET_CATALOG_UPDATE_LENGTH_SAVE,
    isCatalogUpdateLengthSaved: isCatalogUpdateLengthSaved
});

const getCatalogUpdateLengthValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_LENGTH_VALIDATE,
    payload
});

const setCatalogUpdateLengthValidate = (isCatalogUpdateLengthValid: any) => ({
    type: SET_CATALOG_UPDATE_LENGTH_VALIDATE,
    isCatalogUpdateLengthValid: isCatalogUpdateLengthValid
});

const getCatalogRemoveLength = (payload: any) => ({
    type: GET_CATALOG_REMOVE_LENGTH,
    payload
});

const setCatalogRemoveLength = (isCatalogLengthRemoved: any) => ({
    type: SET_CATALOG_REMOVE_LENGTH,
    isCatalogLengthRemoved: isCatalogLengthRemoved
});

///Autonomous
const getCatalogUpdateAutonomous = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_AUTONOMOUS,
    subTypeId,
    attributeName
});

const setCatalogUpdateAutonomous = (catalogUpdateAutonomous: any) => ({
    type: SET_CATALOG_UPDATE_AUTONOMOUS,
    catalogUpdateAutonomous: catalogUpdateAutonomous
});

const getCatalogUpdateAutonomousSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    payload
});

const setCatalogUpdateAutonomousSave = (isCatalogUpdateAutonomousSaved: any) => ({
    type: SET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    isCatalogUpdateAutonomousSaved: isCatalogUpdateAutonomousSaved
});

const getCatalogUpdateAutonomousValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    payload
});

const setCatalogUpdateAutonomousValidate = (isCatalogUpdateAutonomousValid: any) => ({
    type: SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    isCatalogUpdateAutonomousValid: isCatalogUpdateAutonomousValid
});

const getCatalogRemoveAutonomous = (payload: any) => ({
    type: GET_CATALOG_REMOVE_AUTONOMOUS,
    payload
});

const setCatalogRemoveAutonomous = (isCatalogAutonomousRemoved: any) => ({
    type: SET_CATALOG_REMOVE_AUTONOMOUS,
    isCatalogAutonomousRemoved: isCatalogAutonomousRemoved
});

///Category
const getCatalogUpdateCategory = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY,
    subTypeId,
    attributeName
});

const setCatalogUpdateCategory = (catalogUpdateCategory: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY,
    catalogUpdateCategory: catalogUpdateCategory
});

const getCatalogUpdateCategorySave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY_SAVE,
    payload
});

const setCatalogUpdateCategorySave = (isCatalogUpdateCategorySaved: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY_SAVE,
    isCatalogUpdateCategorySaved: isCatalogUpdateCategorySaved
});

const getCatalogUpdateCategoryValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    payload
});

const setCatalogUpdateCategoryValidate = (isCatalogUpdateCategoryValid: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    isCatalogUpdateCategoryValid: isCatalogUpdateCategoryValid
});

const getCatalogRemoveCategory = (payload: any) => ({
    type: GET_CATALOG_REMOVE_CATEGORY,
    payload
});

const setCatalogRemoveCategory = (isCatalogCategoryRemoved: any) => ({
    type: SET_CATALOG_REMOVE_CATEGORY,
    isCatalogCategoryRemoved: isCatalogCategoryRemoved
});

///Category Type
const getCatalogUpdateCategoryType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY_TYPE,
    subTypeId,
    attributeName
});

const setCatalogUpdateCategoryType = (catalogUpdateCategoryType: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY_TYPE,
    catalogUpdateCategoryType: catalogUpdateCategoryType
});

const getCatalogUpdateCategoryTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    payload
});

const setCatalogUpdateCategoryTypeSave = (isCatalogUpdateCategoryTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    isCatalogUpdateCategoryTypeSaved: isCatalogUpdateCategoryTypeSaved
});

const getCatalogUpdateCategoryTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    payload
});

const setCatalogUpdateCategoryTypeValidate = (isCatalogUpdateCategoryTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    isCatalogUpdateCategoryTypeValid: isCatalogUpdateCategoryTypeValid
});

const getCatalogRemoveCategoryType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_CATEGORY_TYPE,
    payload
});

const setCatalogRemoveCategoryType = (isCatalogCategoryTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_CATEGORY_TYPE,
    isCatalogCategoryTypeRemoved: isCatalogCategoryTypeRemoved
});

///Category2
const getCatalogUpdateCategory2 = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY2,
    subTypeId,
    attributeName
});

const setCatalogUpdateCategory2 = (catalogUpdateCategory2: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY2,
    catalogUpdateCategory2: catalogUpdateCategory2
});

const getCatalogUpdateCategory2Save = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY2_SAVE,
    payload
});

const setCatalogUpdateCategory2Save = (isCatalogUpdateCategory2Saved: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY2_SAVE,
    isCatalogUpdateCategory2Saved: isCatalogUpdateCategory2Saved
});

const getCatalogUpdateCategory2Validate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    payload
});

const setCatalogUpdateCategory2Validate = (isCatalogUpdateCategory2Valid: any) => ({
    type: SET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    isCatalogUpdateCategory2Valid: isCatalogUpdateCategory2Valid
});

const getCatalogRemoveCategory2 = (payload: any) => ({
    type: GET_CATALOG_REMOVE_CATEGORY2,
    payload
});

const setCatalogRemoveCategory2 = (isCatalogCategory2Removed: any) => ({
    type: SET_CATALOG_REMOVE_CATEGORY2,
    isCatalogCategory2Removed: isCatalogCategory2Removed
});


//Type
const getCatalogUpdateType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_TYPE,
    subTypeId,
    attributeName
});

const setCatalogUpdateType = (catalogUpdateType: any) => ({
    type: SET_CATALOG_UPDATE_TYPE,
    catalogUpdateType
});

const getCatalogUpdateTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_TYPE_SAVE,
    payload
});

const setCatalogUpdateTypeSave = (isCatalogUpdateTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_TYPE_SAVE,
    isCatalogUpdateTypeSaved
});

const getCatalogUpdateTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_TYPE_VALIDATE,
    payload
});

const setCatalogUpdateTypeValidate = (isCatalogUpdateTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_TYPE_VALIDATE,
    isCatalogUpdateTypeValid
});

const getCatalogRemoveType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_TYPE,
    payload
});

const setCatalogRemoveType = (isCatalogTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_TYPE,
    isCatalogTypeRemoved
});

//Tags
const getTagsList = (payload: any, attributeName: any) => ({
    type: GET_TAGS_LIST,
    payload,
    attributeName
});

const setTagsList = (list: any) => ({
    type: SET_TAGS_LIST,
    list
});

const saveTagsOption = (payload: any) => ({
    type: SAVE_TAGS_OPTION,
    payload
});

const isTagsOptionSaved = (value: any) => ({
    type: IS_TAGS_OPTION_SAVED,
    value
});

const validateTagsOption = (payload: any) => ({
    type: VALIDATE_TAGS_OPTION,
    payload
});

const isTagsOptionValid = (value: any) => ({
    type: IS_TAGS_OPTION_VALID,
    value
});

const deleteTagsOption = (payload: any) => ({
    type: DELETE_TAGS_OPTION,
    payload
});

const isTagsOptionDeleted = (value: any) => ({
    type: IS_TAGS_OPTION_DELETED,
    value
});

// Edit vehicle capacity
const getEditCatalogVehicleCapacity = (val?: any) => ({
    type: GET_EDIT_CATALOG_VEHICLE_CAPACITY,
    val
});

const setEditCatalogVehicleCapacity = (isVehicleCapacityEdited: any) => ({
    type: SET_EDIT_CATALOG_VEHICLE_CAPACITY,
    isVehicleCapacityEdited : isVehicleCapacityEdited
});

///VehicleClass
const getCatalogUpdateVehicleClass = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_VEHICLE_CLASS,
    subTypeId, attributeName
});

const setCatalogUpdateVehicleClass = (catalogUpdateVehicleClass: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_CLASS,
    catalogUpdateVehicleClass: catalogUpdateVehicleClass
});

const getCatalogUpdateVehicleClassSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    payload
});

const setCatalogUpdateVehicleClassSave = (isCatalogUpdateVehicleClassSaved: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    isCatalogUpdateVehicleClassSaved: isCatalogUpdateVehicleClassSaved
});

const getCatalogUpdateVehicleClassValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    payload
});

const setCatalogUpdateVehicleClassValidate = (isCatalogUpdateVehicleClassValid: any) => ({
    type: SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    isCatalogUpdateVehicleClassValid: isCatalogUpdateVehicleClassValid
});


const getCatalogRemoveVehicleClass = (payload: any) => ({
    type: GET_CATALOG_REMOVE_VEHICLE_CLASS,
    payload
});

const setCatalogRemoveVehicleClass = (isCatalogVehicleClassRemoved: any) => ({
    type: SET_CATALOG_REMOVE_VEHICLE_CLASS,
    isCatalogVehicleClassRemoved: isCatalogVehicleClassRemoved
});

///GroupType
const getCatalogUpdateGroupType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_GROUP_TYPE,
    subTypeId, attributeName
});

const setCatalogUpdateGroupType = (catalogUpdateGroupType: any) => ({
    type: SET_CATALOG_UPDATE_GROUP_TYPE,
    catalogUpdateGroupType: catalogUpdateGroupType
});

const getCatalogUpdateGroupTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    payload
});

const setCatalogUpdateGroupTypeSave = (isCatalogUpdateGroupTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    isCatalogUpdateGroupTypeSaved: isCatalogUpdateGroupTypeSaved
});

const getCatalogUpdateGroupTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    payload
});

const setCatalogUpdateGroupTypeValidate = (isCatalogUpdateGroupTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    isCatalogUpdateGroupTypeValid: isCatalogUpdateGroupTypeValid
});


const getCatalogRemoveGroupType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_GROUP_TYPE,
    payload
});

const setCatalogRemoveGroupType = (isCatalogGroupTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_GROUP_TYPE,
    isCatalogGroupTypeRemoved: isCatalogGroupTypeRemoved
});

///ClassType
const getCatalogUpdateClassType = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_CLASS_TYPE,
    subTypeId, attributeName
});

const setCatalogUpdateClassType = (catalogUpdateClassType: any) => ({
    type: SET_CATALOG_UPDATE_CLASS_TYPE,
    catalogUpdateClassType: catalogUpdateClassType
});

const getCatalogUpdateClassTypeSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    payload
});

const setCatalogUpdateClassTypeSave = (isCatalogUpdateClassTypeSaved: any) => ({
    type: SET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    isCatalogUpdateClassTypeSaved: isCatalogUpdateClassTypeSaved
});

const getCatalogUpdateClassTypeValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    payload
});

const setCatalogUpdateClassTypeValidate = (isCatalogUpdateClassTypeValid: any) => ({
    type: SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    isCatalogUpdateClassTypeValid: isCatalogUpdateClassTypeValid
});


const getCatalogRemoveClassType = (payload: any) => ({
    type: GET_CATALOG_REMOVE_CLASS_TYPE,
    payload
});

const setCatalogRemoveClassType = (isCatalogClassTypeRemoved: any) => ({
    type: SET_CATALOG_REMOVE_CLASS_TYPE,
    isCatalogClassTypeRemoved: isCatalogClassTypeRemoved
});

///GrossWeight
const getCatalogUpdateGrossWeight = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_GROSS_WEIGHT,
    subTypeId, attributeName
});

const setCatalogUpdateGrossWeight = (catalogUpdateGrossWeight: any) => ({
    type: SET_CATALOG_UPDATE_GROSS_WEIGHT,
    catalogUpdateGrossWeight: catalogUpdateGrossWeight
});

const getCatalogUpdateGrossWeightSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    payload
});

const setCatalogUpdateGrossWeightSave = (isCatalogUpdateGrossWeightSaved: any) => ({
    type: SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    isCatalogUpdateGrossWeightSaved: isCatalogUpdateGrossWeightSaved
});

const getCatalogUpdateGrossWeightValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    payload
});

const setCatalogUpdateGrossWeightValidate = (isCatalogUpdateGrossWeightValid: any) => ({
    type: SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    isCatalogUpdateGrossWeightValid: isCatalogUpdateGrossWeightValid
});


const getCatalogRemoveGrossWeight = (payload: any) => ({
    type: GET_CATALOG_REMOVE_GROSS_WEIGHT,
    payload
});

const setCatalogRemoveGrossWeight = (isCatalogGrossWeightRemoved: any) => ({
    type: SET_CATALOG_REMOVE_GROSS_WEIGHT,
    isCatalogGrossWeightRemoved: isCatalogGrossWeightRemoved
});

///Trim
const getCatalogUpdateTrim = (subTypeId: any, attributeName: any) => ({
    type: GET_CATALOG_UPDATE_TRIM,
    subTypeId, attributeName
});

const setCatalogUpdateTrim = (catalogUpdateTrim: any) => ({
    type: SET_CATALOG_UPDATE_TRIM,
    catalogUpdateTrim: catalogUpdateTrim
});

const getCatalogUpdateTrimSave = (payload: any) => ({
    type: GET_CATALOG_UPDATE_TRIM_SAVE,
    payload
});

const setCatalogUpdateTrimSave = (isCatalogUpdateTrimSaved: any) => ({
    type: SET_CATALOG_UPDATE_TRIM_SAVE,
    isCatalogUpdateTrimSaved: isCatalogUpdateTrimSaved
});

const getCatalogUpdateTrimValidate = (payload: any) => ({
    type: GET_CATALOG_UPDATE_TRIM_VALIDATE,
    payload
});

const setCatalogUpdateTrimValidate = (isCatalogUpdateTrimValid: any) => ({
    type: SET_CATALOG_UPDATE_TRIM_VALIDATE,
    isCatalogUpdateTrimValid: isCatalogUpdateTrimValid
});


const getCatalogRemoveTrim = (payload: any) => ({
    type: GET_CATALOG_REMOVE_TRIM,
    payload
});

const setCatalogRemoveTrim = (isCatalogTrimRemoved: any) => ({
    type: SET_CATALOG_REMOVE_TRIM,
    isCatalogTrimRemoved: isCatalogTrimRemoved
});

export {
    setCatalogUpdateNoOfDoors,
    getCatalogUpdateNoOfDoors,
    getCatalogUpdateNoOfDoorSave,
    setCatalogUpdateNoOfDoorSave,
    getCatalogUpdateNoOfDoorValidate,
    setCatalogUpdateNoOfDoorValidate,
    getCatalogRemoveNoOfDoor,
    setCatalogRemoveNoOfDoor,
    getCatalogUpdateYear,
    setCatalogUpdateYear,
    getCatalogUpdateYearSave,
    setCatalogUpdateYearSave,
    getCatalogUpdateYearValidate,
    setCatalogUpdateYearValidate,
    getCatalogRemoveYear,
    setCatalogRemoveYear,
    getCatalogUpdateCapacity,
    setCatalogUpdateCapacity,
    getCatalogUpdateCapacitySave,
    setCatalogUpdateCapacitySave,
    getCatalogUpdateCapacityValidate,
    setCatalogUpdateCapacityValidate,
    getCatalogRemoveCapacity,
    setCatalogRemoveCapacity,
    getCatalogUpdateUpfit,
    setCatalogUpdateUpfit,
    getCatalogUpdateUpfitSave,
    setCatalogUpdateUpfitSave,
    getCatalogUpdateUpfitValidate,
    setCatalogUpdateUpfitValidate,
    getCatalogRemoveUpfit,
    setCatalogRemoveUpfit,
    getCatalogUpdateDriveTrain,
    setCatalogUpdateDriveTrain,
    getCatalogUpdateDriveTrainSave,
    setCatalogUpdateDriveTrainSave,
    getCatalogUpdateDriveTrainValidate,
    setCatalogUpdateDriveTrainValidate,
    getCatalogRemoveDriveTrain,
    setCatalogRemoveDriveTrain,
    getCatalogUpdatePowerType,
    setCatalogUpdatePowerType,
    getCatalogUpdatePowerTypeSave,
    setCatalogUpdatePowerTypeSave,
    getCatalogUpdatePowerTypeValidate,
    setCatalogUpdatePowerTypeValidate,
    getCatalogRemovePowerType,
    setCatalogRemovePowerType,
    getCatalogUpdateVehicleLevel,
    setCatalogUpdateVehicleLevel,
    getCatalogUpdateVehicleLevelSave,
    setCatalogUpdateVehicleLevelSave,
    getCatalogUpdateVehicleLevelValidate,
    setCatalogUpdateVehicleLevelValidate,
    getCatalogRemoveVehicleLevel,
    setCatalogRemoveVehicleLevel,
    getCatalogUpdateEqClassCode,
    setCatalogUpdateEqClassCode,
    getCatalogUpdateEqClassCodeSave,
    setCatalogUpdateEqClassCodeSave,
    getCatalogUpdateEqClassCodeValidate,
    setCatalogUpdateEqClassCodeValidate,
    getCatalogRemoveEqClassCode,
    setCatalogRemoveEqClassCode,
    getCatalogUpdateMake,
    setCatalogUpdateMake,
    getCatalogUpdateMakeSave,
    setCatalogUpdateMakeSave,
    getCatalogUpdateMakeValidate,
    setCatalogUpdateMakeValidate,
    getCatalogRemoveMake,
    setCatalogRemoveMake,
    getCatalogUpdateStateAvailability,
    setCatalogUpdateStateAvailability,
    getCatalogUpdateStateAvailabilitySave,
    setCatalogUpdateStateAvailabilitySave,
    getCatalogUpdateStateAvailabilityValidate,
    setCatalogUpdateStateAvailabilityValidate,
    getCatalogRemoveStateAvailability,
    setCatalogRemoveStateAvailability,
    getCatalogUpdateModelSave,
    setCatalogUpdateModelSave,
    getCatalogUpdateModelValidate,
    setCatalogUpdateModelValidate,
    getCatalogUpdateModel,
    setCatalogUpdateModel,
    getCatalogRemoveModel,
    setCatalogRemoveModel,

    getBudgetingPercentList,
    setBudgetingPercentList,
    saveBudgetingPercentOption,
    isBudgetingPercentOptionSaved,
    validateBudgetingPercentOption,
    isBudgetingPercentOptionValid,
    deleteBudgetingPercentOption,
    isBudgetingPercentOptionDeleted,

    getUsefulLifeList,
    setUsefulLifeList,
    saveUsefulLifeOption,
    isUsefulLifeOptionSaved,
    validateUsefulLifeOption,
    isUsefulLifeOptionValid,
    deleteUsefulLifeOption,
    isUsefulLifeOptionDeleted,

    getCatalogUpdateProgramStatus,
    setCatalogUpdateProgramStatus,
    getCatalogUpdateProgramStatusSave,
    setCatalogUpdateProgramStatusSave,
    getCatalogUpdateProgramStatusValidate,
    setCatalogUpdateProgramStatusValidate,
    getCatalogRemoveProgramStatus,
    setCatalogRemoveProgramStatus,

    getCatalogUpdateAnnualHours,
    setCatalogUpdateAnnualHours,
    getCatalogUpdateAnnualHoursSave,
    setCatalogUpdateAnnualHoursSave,
    getCatalogUpdateAnnualHoursValidate,
    setCatalogUpdateAnnualHoursValidate,
    getCatalogRemoveAnnualHours,
    setCatalogRemoveAnnualHours,

    getCatalogUpdateDeckSize,
    setCatalogUpdateDeckSize,
    getCatalogUpdateDeckSizeSave,
    setCatalogUpdateDeckSizeSave,
    getCatalogUpdateDeckSizeValidate,
    setCatalogUpdateDeckSizeValidate,
    getCatalogRemoveDeckSize,
    setCatalogRemoveDeckSize,

    getCatalogUpdateDeckType,
    setCatalogUpdateDeckType,
    getCatalogUpdateDeckTypeSave,
    setCatalogUpdateDeckTypeSave,
    getCatalogUpdateDeckTypeValidate,
    setCatalogUpdateDeckTypeValidate,
    getCatalogRemoveDeckType,
    setCatalogRemoveDeckType,

    getCatalogUpdateSize,
    setCatalogUpdateSize,
    getCatalogUpdateSizeSave,
    setCatalogUpdateSizeSave,
    getCatalogUpdateSizeValidate,
    setCatalogUpdateSizeValidate,
    getCatalogRemoveSize,
    setCatalogRemoveSize,

    getCatalogUpdateLength,
    setCatalogUpdateLength,
    getCatalogUpdateLengthSave,
    setCatalogUpdateLengthSave,
    getCatalogUpdateLengthValidate,
    setCatalogUpdateLengthValidate,
    getCatalogRemoveLength,
    setCatalogRemoveLength,

    getCatalogUpdateAutonomous,
    setCatalogUpdateAutonomous,
    getCatalogUpdateAutonomousSave,
    setCatalogUpdateAutonomousSave,
    getCatalogUpdateAutonomousValidate,
    setCatalogUpdateAutonomousValidate,
    getCatalogRemoveAutonomous,
    setCatalogRemoveAutonomous,

    getCatalogUpdateCategory,
    setCatalogUpdateCategory,
    getCatalogUpdateCategorySave,
    setCatalogUpdateCategorySave,
    getCatalogUpdateCategoryValidate,
    setCatalogUpdateCategoryValidate,
    getCatalogRemoveCategory,
    setCatalogRemoveCategory,

    getCatalogUpdateCategoryType,
    setCatalogUpdateCategoryType,
    getCatalogUpdateCategoryTypeSave,
    setCatalogUpdateCategoryTypeSave,
    getCatalogUpdateCategoryTypeValidate,
    setCatalogUpdateCategoryTypeValidate,
    getCatalogRemoveCategoryType,
    setCatalogRemoveCategoryType,

    getCatalogUpdateCategory2,
    setCatalogUpdateCategory2,
    getCatalogUpdateCategory2Save,
    setCatalogUpdateCategory2Save,
    getCatalogUpdateCategory2Validate,
    setCatalogUpdateCategory2Validate,
    getCatalogRemoveCategory2,
    setCatalogRemoveCategory2,

    getCatalogUpdateType,
    setCatalogUpdateType,
    getCatalogUpdateTypeSave,
    setCatalogUpdateTypeSave,
    getCatalogUpdateTypeValidate,
    setCatalogUpdateTypeValidate,
    getCatalogRemoveType,
    setCatalogRemoveType,

    getTagsList,
    setTagsList,
    saveTagsOption,
    isTagsOptionSaved,
    validateTagsOption,
    isTagsOptionValid,
    deleteTagsOption,
    isTagsOptionDeleted,

    getEditCatalogVehicleCapacity,
    setEditCatalogVehicleCapacity,

    getCatalogUpdateVehicleClass,
    setCatalogUpdateVehicleClass,
    getCatalogUpdateVehicleClassSave,
    setCatalogUpdateVehicleClassSave,
    getCatalogUpdateVehicleClassValidate,
    setCatalogUpdateVehicleClassValidate,
    getCatalogRemoveVehicleClass,
    setCatalogRemoveVehicleClass,

    getCatalogUpdateGroupType,
    setCatalogUpdateGroupType,
    getCatalogUpdateGroupTypeSave,
    setCatalogUpdateGroupTypeSave,
    getCatalogUpdateGroupTypeValidate,
    setCatalogUpdateGroupTypeValidate,
    getCatalogRemoveGroupType,
    setCatalogRemoveGroupType,

    getCatalogUpdateClassType,
    setCatalogUpdateClassType,
    getCatalogUpdateClassTypeSave,
    setCatalogUpdateClassTypeSave,
    getCatalogUpdateClassTypeValidate,
    setCatalogUpdateClassTypeValidate,
    getCatalogRemoveClassType,
    setCatalogRemoveClassType,

    getCatalogUpdateGrossWeight,
    setCatalogUpdateGrossWeight,
    getCatalogUpdateGrossWeightSave,
    setCatalogUpdateGrossWeightSave,
    getCatalogUpdateGrossWeightValidate,
    setCatalogUpdateGrossWeightValidate,
    getCatalogRemoveGrossWeight,
    setCatalogRemoveGrossWeight,

    getCatalogUpdateTrim,
    setCatalogUpdateTrim,
    getCatalogUpdateTrimSave,
    setCatalogUpdateTrimSave,
    getCatalogUpdateTrimValidate,
    setCatalogUpdateTrimValidate,
    getCatalogRemoveTrim,
    setCatalogRemoveTrim,
}
